export default __webpack_public_path__ + "static/media/01.e6ed573f.svg";